{
  "$schema": "./language-config.schema.json",
  "defaultLanguage": "it",
  "defaultLocale": "it-IT",
  "languages": [
    {
      "code": "it",
      "locale": "it-IT",
      "name": "Italiano",
      "enabled": true
    },
    {
      "code": "en",
      "locale": "en-US",
      "name": "English",
      "enabled": true
    },
    {
      "code": "de",
      "locale": "de-DE",
      "name": "Deutsch",
      "enabled": true
    },
    {
      "code": "es",
      "locale": "es-ES",
      "name": "Español",
      "enabled": true
    },
    {
      "code": "fr",
      "locale": "fr-FR",
      "name": "Français",
      "enabled": true
    },
    {
      "code": "pl",
      "locale": "pl-PL",
      "name": "Polski",
      "enabled": true
    },
    {
      "code": "cs",
      "locale": "cs-CZ",
      "name": "Čeština",
      "enabled": true
    },
    {
      "code": "sk",
      "locale": "sk-SK",
      "name": "Slovenčina",
      "enabled": true
    },
    {
      "code": "sq",
      "locale": "sq-AL",
      "name": "Shqip",
      "enabled": true
    },
    {
      "code": "bg",
      "locale": "bg-BG",
      "name": "Български",
      "enabled": true
    },
    {
      "code": "hr",
      "locale": "hr-HR",
      "name": "Hrvatski",
      "enabled": true
    },
    {
      "code": "mk",
      "locale": "mk-MK",
      "name": "Македонски",
      "enabled": true
    },
    {
      "code": "cnr",
      "locale": "cnr-ME",
      "name": "Црногорски",
      "enabled": true
    },
    {
      "code": "sr",
      "locale": "sr-RS",
      "name": "Српски",
      "enabled": true
    },
    {
      "code": "el",
      "locale": "el-GR",
      "name": "Ελληνικά",
      "enabled": true
    },
    {
      "code": "hu",
      "locale": "hu-HU",
      "name": "Magyar",
      "enabled": true
    },
    {
      "code": "sl",
      "locale": "sl-SI",
      "name": "Slovenščina",
      "enabled": true
    }
  ],
  "debugLanguage": {
    "code": "zz",
    "locale": "zz-ZZ",
    "name": "Debug",
    "enabled": false
  }
}
